module.exports = __webpack_public_path__ + "img/people_more.6b42a6f3.png";